<template>
  <div class="container" :class="[{ inactive: isInactive }]">
    <p>{{ text }}</p>
  </div>
</template>

<script>
export default {
	props:{
		text:String,
		isInactive:Boolean
	}

}
</script>

<style scoped>
.container {
  width: 100%;
  padding: 0.4em 0;
  font-size: 1.3em;
  color: var(--bg-color);
  background-color: var(--main-color);
  border-radius: 2em;
  text-align: center;
}

.container.inactive {
  background-color: var(--weak-color);
}
</style>